import { Route, Redirect } from "react-router-dom";
import { isLogged } from "../services/UserService";

const PublicRoute = ({ component: Component, accessAuthUser, ...rest }: any) => {
  return (
    <Route {...rest} render={(props) => !isLogged() || (isLogged() && accessAuthUser) ? <Component {...props} /> : <Redirect to="/Dashboard" /> } />
  );
};

export default PublicRoute;